import { utils as u, Progress, Tooltip } from 'edrolo-ui';
import { Exam } from '../../../../../../../types/Assemblage';
import { useClassProgress } from 'edrolo/domains/bySchoolClass';
import { useContext } from 'react';
import { ClassContext } from 'edrolo/context';

export interface Props {
  exam: Exam;
}

export const SubmissionsProgress = ({ exam }: Props) => {
  const {
    data: { classId, classDetail },
  } = useContext(ClassContext);

  const { data, loading, error } = useClassProgress(classId);

  if (loading || error) {
    return null;
  }

  const submissions = data.exams[exam.id]?.submission_count || 0;
  const totalStudents = classDetail
    ? Object.keys(classDetail?.students).length
    : 0;

  return (
    <Tooltip
      tip={`${submissions} out of ${totalStudents} students have submitted an assessment`}
    >
      <Progress.Circle
        numerator={submissions}
        denominator={totalStudents}
        className={u.mr2}
      />
    </Tooltip>
  );
};
